













































































import { Getter, Action } from 'vuex-class';
import { Vue, Component } from 'vue-property-decorator';
import fetch from '@/common/api/fetch';

import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import { getInputStyle } from '@/common/utils/getStyles';
import { replaceString } from '@/common/utils/dealWithString';
import { isMobile } from '@/common/utils/getPlaform';

import { QuillEditor, IntroItem } from '@/common/interface';
import FieldButton from '@/components/common/edit/FieldButton.vue';
import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import EditTitleModal from '@/components/common/edit/EditTitleModal.vue';
import RuleIntroList from './RuleIntroList.vue';
import { majorNoticeText } from '@/common/constants/index';

const IconVideo = 'https://image.xiaomaiketang.com/xm/rfxJ5Yidac.png';
const IconImg = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311697436.png?x-oss-process=image/resize,w_300,limit_0';
const FieldText = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311714121.png?x-oss-process=image/resize,w_300,limit_0';

interface Payload {
  item: IntroItem;
}

@Component({
  components: {
    'field-button': FieldButton,
    'activity-label': ActivityLabel,
    'edit-title-modal': EditTitleModal,
    'rule-intro-list': RuleIntroList
  }
})
export default class RuleIntro extends Vue {
  @Getter('activityIntrosTextNum') activityIntrosTextNum!: number;
  @Getter('activityIntrosImgNum') activityIntrosImgNum!: number;
  @Getter('activityRule') activityRule!: string;
  @Getter('activityTitle') activityTitle!: string;
  @Getter('activitySwitch') activitySwitch!: boolean;
  @Getter('section') section!: any;
  @Getter('orgId') orgId!: string;
  @Getter('xcxType') xcxType!: string;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('activityIntros') getterActivityIntros!: Array<IntroItem>;

  @Action('changeActivityRule') changeActivityRule!: Function;
  @Action('changeActivityTitle') changeActivityTitle!: Function;
  @Action('changeShowFooter') changeShowFooter!: Function;
  @Action('addActivityIntros') addActivityIntros!: Function;

  text!: string;
  getActivityType: Function = getActivityType;
  replaceString: Function = replaceString;
  isMobile: Function = isMobile;
  IconImg: string = IconImg;
  FieldText: string = FieldText;
  IconVideo: string = IconVideo;
  showTitleModal: boolean = false;
  videoList: any = [];
  showVideo: Boolean = false;
  selectItem: any = {};

  get inputStyle() {
    const { inputFontColor, inputBackgroundColor } = this.section;
    return getInputStyle(inputFontColor, inputBackgroundColor);
  }

  onEditorChange(quill: QuillEditor) {
    const { html, text } = quill;
    if (text.length > 1000) {
      const quillDom = this.$refs.ruleQuillEditor as any;
      quillDom.quill.setText(this.text);
      return null;
    }
    this.text = text;
    this.changeActivityRule({
      activityRule: html
    });
  }

  handleAddTextIntro(): void {
    if (this.activityIntrosTextNum < 10) {
      const introItem: IntroItem = {
        type: 'text',
        value: ''
      };
      const payload: Payload = {
        item: introItem
      };
      this.addActivityIntros(payload);
    } else {
      Vue.$toast.info('最多添加10个文本');
    }
  }

  handleAddImage(imgUrl: string): void {
    if (this.activityIntrosImgNum < 10) {
      const filedImgs = document.getElementsByClassName('field-img-upload');
      Array.from(filedImgs).forEach((img: any) => {
        img.value = '';
      });
      const introItem: IntroItem = {
        type: 'img',
        value: imgUrl
      };
      const payload: Payload = {
        item: introItem
      };
      this.addActivityIntros(payload);
    } else {
      Vue.$toast.info('最多添加10个图片');
    }
  }

  handleShowTitleModal(): void {
    this.showTitleModal = true;
    this.changeShowFooter(false);
  }
  handleHideShowTitleModal(): void {
    this.showTitleModal = false;
    this.changeShowFooter(true);
  }

  handleShowVideo(): void {
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }
    this.getVideoList();
    this.showVideo = true;
    this.changeShowFooter(false);
  }
  handleCloseVideo(): void {
    this.selectItem = {};
    this.showVideo = false;
    this.changeShowFooter(true);
  }
  handleToggleSelectItem(item: object): void {
    if (this.selectItem === item) {
      this.selectItem = {};
    } else {
      this.selectItem = item;
    }
  }
  selectVideo(): void {
    if (this.selectItem.videoUrl) {
      const introItem: IntroItem = {
        type: 'video',
        value: this.selectItem.videoUrl,
        coverUrl: this.selectItem.coverUrl
      };
      const payload: Payload = {
        item: introItem
      };
      this.showVideo = false;
      this.addActivityIntros(payload);
      this.changeShowFooter(true);
    }
  }

  getVideoList() {
    const instId = getUrlParam('instId');
    const activityId = getUrlParam('broadcastId');
    if (instId) {
      return fetch.Sales('anon/businessShow/getCustomizeVideoList', { instId }).then((res: any) => {
        this.videoList = res.result || [];
        this.videoList.map((item: any) => {
          item.bag = item.coverUrl || item.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast';
        });
        (this.getterActivityIntros || []).map(item => {
          if (item.type == 'video') {
            this.selectItem = {
              videoUrl: item.value,
              coverUrl: item.coverUrl
            };
          }
        });
      });
    } else {
      return fetch.Sales('anon/businessShow/getCustomizeVideoList', { activityId }).then((res: any) => {
        this.videoList = res.result || [];
        this.videoList.map((item: any) => {
          item.bag = item.coverUrl || item.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast';
        });
        (this.getterActivityIntros || []).map(item => {
          if (item.type == 'video') {
            this.selectItem = {
              videoUrl: item.value,
              coverUrl: item.coverUrl
            };
          }
        });
      });
    }
  }
}
